<drawer
  [title]="registration && registration.id ? 'Edit Registration' : 'Add Registration'"
  [showHeaderButtons]="true"
  [hideDelete]="true"
  [hideCancel]="false"
  [hideSave]="false"
  [isClosed]="false"
  (saveEvent)="registration && registration.id ? saveRegistration() : addNewItem()"
  (cancelEvent)="cancel()"
  (closeEvent)="cancel()">
  <div class="drawer-content drawer-direct-content">
    <div class="row fields-group mt-4">
      <div class="col-12">
        <form *ngIf="registration" class="form-validation">
          <!-- General infos -->
          <div class="row">
            <div class="col-md-12">
              <div class="panel-body">
                <div class="form-group">
                  <div class="row pr-3">
                    <div class="col-md-8 col-12">
                      <label class="input-label field-required">{{
                        'reg.name' | translate
                      }}</label>
                      <input
                        class="form-control"
                        type="text"
                        name="name"
                        [(ngModel)]="registration.name"
                        placeholder="{{ 'reg.name_placeholder' | translate }}"
                        #name="ngModel"
                        [rangeLength]="[2, 256]"
                        minlength="2"
                        maxlength="256"
                        required
                        autofocus
                        (input)="nameChanged($event.target.value)"
                      />
                      <p
                        class="validation-error"
                        *ngIf="name.errors?.required && (name?.dirty && name?.touched)">
                        {{ 'form.validate.required' | translate }}
                      </p>
                      <p
                        class="validation-error"
                        *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
                        {{ 'form.validate.minLenght' | translate }} 2!
                      </p>
                      <p
                        class="validation-error"
                        *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
                        {{ 'form.validate.maxLenght' | translate }} 256!
                      </p>
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="input-label field-required">{{
                        'reg.short_name' | translate
                      }}</label>
                      <input
                        class="form-control"
                        type="text"
                        name="shortName"
                        [(ngModel)]="registration.shortName"
                        placeholder="{{
                          'reg.short_name_placeholder' | translate
                        }}"
                        #shortName="ngModel"
                        [rangeLength]="[2, 20]"
                        minlength="2"
                        maxlength="20"
                        required
                        autofocus
                      />
                      <p
                        class="validation-error"
                        *ngIf="shortName.errors?.required && (shortName?.dirty && name?.touched)">
                        {{ 'form.validate.required' | translate }}
                      </p>
                      <p
                        class="validation-error"
                        *ngIf="shortName.errors?.rangeLength && (shortName?.dirty && shortName?.touched)">
                        {{ 'form.validate.minLenght' | translate }} 2!
                      </p>
                      <p
                        class="validation-error"
                        *ngIf="shortName.errors?.rangeLength && (shortName?.dirty && name?.touched)">
                        {{ 'form.validate.maxLenght' | translate }} 20!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</drawer>
